import values from "lodash/values";
import uniqBy from "lodash/uniqBy";
import get from "lodash/get";
import fromPairs from "lodash/fromPairs";
import assign from "lodash/assign";
import keys from "lodash/keys";
export var mergeEntities = function (entity) {
    var entities = [].concat(entity);
    if (entities.length === 1)
        return entities[0];
    var entityKeys = Array.from(new Set(entities.map(function (e) { return !e ? [] : keys(e); }).flat()));
    var cache = new WeakMap();
    cache.set(entity, {});
    var flatEntityArray = function (key) {
        var _a;
        var cachedValue = get(cache.get(entity), key);
        if (cachedValue)
            return cachedValue;
        assign(cache.get(entity), (_a = {},
            _a[key] = uniqBy(entities.map(function (e) { var _a; return values((_a = e[key]) !== null && _a !== void 0 ? _a : []); }).flat(), "attributes.id"),
            _a));
        return get(cache.get(entity), key);
    };
    return new Proxy(fromPairs(entityKeys.map(function (key) { return [key]; })), {
        get: function (target, prop) {
            return (prop in target) ? flatEntityArray(prop) : undefined;
        }
    });
};
